/** A parsed CSV: the column names from the first non-empty row, then the data rows. */
export type CsvTable = { headers: string[]; rows: string[][] };

/** Parses CSV text. Handles quoted fields, doubled quotes inside them, CRLF and LF line endings, and a leading BOM.
 *  Rows with only blank cells are dropped. */
export function parseCsv(text: string): CsvTable {
  const src = text.replace(/^﻿/, "");
  const table: string[][] = [];
  let row: string[] = [];
  let field = "";
  let quoted = false;

  for (let i = 0; i < src.length; i++) {
    const ch = src[i];
    if (quoted) {
      if (ch === '"') {
        if (src[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          quoted = false;
        }
      } else {
        field += ch;
      }
    } else if (ch === '"') {
      quoted = true;
    } else if (ch === ",") {
      row.push(field);
      field = "";
    } else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && src[i + 1] === "\n") i++;
      row.push(field);
      table.push(row);
      row = [];
      field = "";
    } else {
      field += ch;
    }
  }
  if (field !== "" || row.length > 0) {
    row.push(field);
    table.push(row);
  }

  const filled = table.filter((r) => r.some((c) => c.trim() !== ""));
  const [head = [], ...rows] = filled;
  return { headers: head.map((h) => h.trim()), rows };
}
